import { M8ProductType, M8TariffPart } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

type Params = {
  priceCalculationComponentType: M8ProductType;
  discount: number;
  comission: number;
};

export const calculateTarifParts = async (
  params: Params
): Promise<M8TariffPart[]> => {
  const response = await customFetch(
    getM8AdminURL(`calculateTarifParts?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
